@if (this.isVisible == true) {
  <button
    style="padding: 5px 5px 0px 5px; margin: 0px"
    (click)="this.openSessionDetails()"
  >
    <mat-icon>personal_video</mat-icon> Host
  </button>
}
